import React, { Component } from 'react'
import { getCookie, setCookie } from '../Helper/CookieHelper';
import Service from "../Networking/networkutils";

// const user = JSON.parse(getCookie("bb_ts_user"));
var access = JSON.parse(getCookie("bb_ts_access"));

export default class ExtDomainAuth extends Component {

    constructor(props) {
        super(props)

        this.state = {
            auth: true
        }
    }

    componentDidMount() {
        // console.log(window.location.host, access.access.l111a.l111a_d)
        const query = new URLSearchParams(this.props.location.search);
        // alert((moment().add(3, "seconds").format()))

        Service.get(`/bb/api/token/access/`, {
            headers: {
                Authorization: "Token " + getCookie("bb_ts_token"),
            },
        })
            .then(res => {
                if (res.data && res.data[0]) {
                    access = res.data[0]

                    setCookie('bb_ts_access', JSON.stringify(access), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', });

                    if (query.get('url').includes(".bbparam.com") || query.get('url').includes(".bbedcindia.com") || query.get('url').includes(".bbedc.dev")) {
                        window.location = "http://" + (query.get('url'))
                    } else {
                        alert("Domain Not Authorized")
                        this.setState({auth: false})
                    }

                } else {
                    alert("You don't have access!")
                    this.setState({auth: false})

                }

            })
            .catch(error => {
                console.log(error)
                alert("Something went wrong")
            });


    }

    render() {
        return (
            <div style={{padding: '15px'}}>
                {(this.state.auth) ? (<h3>Authenticating...</h3>) : (<h3>Authentication Failed. Please contact PaRaM Support for access. Thank you!</h3>)}
                
            </div>
        )
    }
}
